import { useRef } from 'react';
import useFavoriteApproval from '@/components/Approval/@hooks/useFavoriteApproval';
import useModal from '@/hooks/useModal';
import Modal, { ModalRef } from '@/components/@IntranetLibrary/Modal';
import { useAtom } from 'jotai';
import { approvalFilter, INIT_FILTER } from '@/recoil/atom';
import {
  StyledCancelButton,
  StyledSubmitButton,
} from '@/components/Approval/CategoryContent/TooltipBox/useDeleteItem/styles';
import { t } from 'i18next';
import { useSnackbar } from '@/hooks/global-tools';

type P = {
  title: string;
  favoriteId: string;
  handleClose?: () => void;
};

const useDeleteItem = ({ title, favoriteId, handleClose }: P) => {
  const deleteModalRef = useRef<ModalRef>(null);
  const [filters, setFilters] = useAtom(approvalFilter);
  const toast = useSnackbar();

  const { handleDelete } = useFavoriteApproval();

  const { openModal, closeModal } = useModal(
    deleteModalRef,
    undefined,
    handleClose,
  );

  const handleDeleteFavoriteItem = () => {
    handleDelete(favoriteId).then(() => {
      setFilters(INIT_FILTER);
      closeModal();
      toast?.show({
        message: `'${title}' ${t('내 필터가 삭제되었습니다.')}`,
        severity: 'success',
      });
    });
  };

  const DeleteModal = (
    <div onClick={(e) => e.stopPropagation()}>
      <Modal
        ref={deleteModalRef}
        title={t('내 필터 삭제')}
        size={'x-small'}
        handleClose={closeModal}
      >
        <div>
          <div
            style={{
              whiteSpace: 'pre-wrap',
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
            }}
          >{`'${title}'\n${t('내 필터를 삭제하시겠어요?')}`}</div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '24px' }}>
            <StyledCancelButton type="button" onClick={closeModal}>
              {t('취소')}
            </StyledCancelButton>
            <StyledSubmitButton onClick={handleDeleteFavoriteItem}>
              {t('삭제')}
            </StyledSubmitButton>
          </div>
        </div>
      </Modal>
    </div>
  );
  return { DeleteModal, openModal };
};

export default useDeleteItem;
